import packDataService from "../../services/packsDataService";
import { type AppDispatch } from "../../../../Application/globaltypes/redux";
import { fetchBegin, fetchFailure, fetchSuccess } from "../slices/packBillingTermsSlice";

export const fetchPackBillingTerms = () => async (dispatch: AppDispatch) => {
  dispatch(fetchBegin());
  try {
    const res = await packDataService.getPackBillingTermsAsync();
    dispatch(
      fetchSuccess({
        items: res.data,
        totalCount: res.data.length,
      }),
    );
  } catch (e: any) {
    dispatch(fetchFailure(e));
  }
};
